import { dateConfig, DEVICE_DETAILS, PROJECT, DELETED_STATUS, EDIT_STATUS } from "config";
import {REMOTE, LOCATIONS_COLLECTION} from "config/CONSTANTS";
import moment from "moment";
import {jobTypeITContractor} from 'utils';
import { collectionRef, db } from "./firebase";
import { createTimesheetfromContractorPunch } from "../pages/Timesheet/utils";
import {  getUniqueID } from "../utils/punch";
import { getWeekNumber } from "../services";
import {OPERATIONAL_DISTRICT_BUILDING} from "../pages/AddWorker/config";

const PUNCHES = "punches";


export function saveBulkEntries(data, existingPunches={}) {
  console.log("bulkUploadData ", data);
  let batch = db.batch();
  let start = data.weekPicker;
  let {weekTotal={}} = data
  //let index = 0;
  const selectedWorker = data && data.selectedWorker ? data.selectedWorker : {};
  return new Promise(async (resolve, reject) => {
    try {
      let operationalBuilding = OPERATIONAL_DISTRICT_BUILDING.Building;
      let operationalDistrict = OPERATIONAL_DISTRICT_BUILDING.District;
      if(selectedWorker && selectedWorker.operationalBuilding && selectedWorker.operationalBuilding.length > 0){
        let workerBuilding = Array.isArray(selectedWorker.operationalBuilding) ? selectedWorker.operationalBuilding[0]: selectedWorker.operationalBuilding;
         await collectionRef(LOCATIONS_COLLECTION).where(`buildings.${workerBuilding}`, ">=" , "").get().then((snapshot) => {
          if(snapshot && snapshot.docs.length > 0){
            const data = snapshot.docs[0].data();
            if(data && data.districtName){
              operationalDistrict = data.districtName;
              operationalBuilding = workerBuilding;
            }
          }
        })
      }
      let records = data.updatedRecords;
      // let punches = Array.from(Array(7)).map(e=>[]);
      let punches = [];
      let existingPunchesModify = {};
      if(existingPunches && existingPunches.punchesToBeDeleted && Object.keys(existingPunches.punchesToBeDeleted).length>0){
        if(existingPunches.deletedPunches && existingPunches.deletedPunches.length>0){
          punches = [...existingPunches.deletedPunches];
        }
        existingPunchesModify = {...existingPunches.punchesToBeDeleted};
      }
      console.log("Arrays", punches, existingPunchesModify);

      for (let i = 0; i < 7; ++i) {
        let day = `day${i + 1}`;
        let rowIndex = 0;
        let startTime = '08:00';
        let previousEndTime = 0;
        if(data.workerSchedule 
            && Object.keys(data.workerSchedule).length > 0 
            && data.workerSchedule.workingHoursEnabled
            ){
                  let workerSchedule = data.workerSchedule;
                  let curDayName = moment().day(i).format('dddd');
                  let workerDaySlots = workerSchedule?.[curDayName]?.slots;
                  let startTimeSlot = workerDaySlots && workerDaySlots.length>0 ?workerDaySlots[0]?.start:undefined;
                  if(startTimeSlot){
                    startTime = moment(startTimeSlot,['hh:mma']).format('HH:mm');
                  }
            }
        if(weekTotal && Object.keys(weekTotal).length > 0 && weekTotal[day] && weekTotal[day]['hours'] && weekTotal[day]['hours'] > 0){
          let dayTotal = parseFloat(weekTotal[day]['hours']);
          let startHours = moment.duration(startTime).hours();
          let totalHours = dayTotal + startHours;
          if(totalHours >= 24 ){
            startTime = "00:00";
          }
        }
        for (let j = 0; j < records.length; ++j) {
          let record = records[j];
          let hours = record[day];
          let punchId = "" ;
            if(existingPunches && existingPunches[day] && record.details 
              && existingPunches[day][record.details] ){
              punchId = existingPunches[day][record.details]['id'] ;
              existingPunchesModify [punchId] = existingPunches[day][record.details];
              }
          if ((hours !== 0 && hours > 0)) {
            rowIndex++;
            if (rowIndex == 1) {
              // First Day Record In column
              let punch = {};

              //let endTime = parseFloat(startTime) + parseFloat(hours);
              let endTime = moment(startTime, 'HH:mm').add(hours, 'hours').format('HH:mm');
              previousEndTime = endTime;

              let inLocalTS = moment(start)
                .startOf("week")
                .add(i, "days")
                .add(moment.duration(startTime))
                .format(dateConfig.format4)
                .toString();
              let outLocalTS = endTime === "00:00" ? 
                  moment(start)
                    .startOf("week")
                    .add(i+1, "days")
                    .add(moment.duration(endTime))
                    .format(dateConfig.format4)
                    .toString()
                  : moment(start)
                    .startOf("week")
                    .add(i, "days")
                    .add(moment.duration(endTime))
                    .format(dateConfig.format4)
                    .toString();
              punch.inLocalTS = inLocalTS;
              punch.outLocalTS = outLocalTS;
              punch.inTS = new Date(inLocalTS).toISOString();
              punch.outTS = new Date(outLocalTS).toISOString();
              if(selectedWorker.timezone 
                && Object.keys(selectedWorker.timezone).length>0
                && selectedWorker.timezone.offset
                ){
                punch.inTS =  moment(inLocalTS).subtract(selectedWorker.timezone.offset * 60 * 60 * 1000).format( 'YYYY-MM-DDTHH:mm:ss.000')+'Z';
                punch.outTS = moment(outLocalTS).subtract(selectedWorker.timezone.offset * 60 * 60 * 1000).format( 'YYYY-MM-DDTHH:mm:ss.000')+'Z';
              }
              punch.actionBy = data.actionBy;
              punch.actionTS = data.actionTS;
              punch.buildingId = operationalBuilding;
              punch.districtId = operationalDistrict;
              punch.customerSite = "";
              if (data.customerSite)
                punch.customerSite = data.customerSite.trim();
              punch.workerId = selectedWorker.workerId;
              punch.activityName = "OUT";
              punch.status = "new";
              punch.category = "punch";
              punch.exceptionName = "";
              punch.isException = false;
              punch.jobName = selectedWorker && selectedWorker.jobRole ? selectedWorker.jobRole : '';
              punch.activityGroup = PROJECT;
              punch.jobProjectInfo = record.details ? record.details : "";
              punch.projectDetails = "";
              if (record.projectDetails)
                punch.projectDetails = record.projectDetails ? record.projectDetails : "";
              punch.weekNumber = getWeekNumber(outLocalTS);
              let duration = 0;
              if (outLocalTS) {
                const end = moment(outLocalTS && outLocalTS.substr(0, 16));
                const start = moment(inLocalTS && inLocalTS.substr(0, 16));
                if (start.isValid() && end.isValid()) {
                  const diff = moment.duration(end.diff(start));
                  duration = diff.asHours();
                  duration = duration.toFixed(2);
                }
              }
              punch.duration = parseFloat(duration);
              const version = getUniqueID();
              punch.version = version;
              if (record.showFreeForm) punch.jobProjectInfo = record.freeForm;
              punch.deviceDetails = DEVICE_DETAILS;
              punch.jobType = selectedWorker.jobType ? selectedWorker.jobType : jobTypeITContractor; 
              if(punchId){
                punch.id = punchId;
                punch.status = EDIT_STATUS;
                let existingPunchDetails = {...existingPunchesModify[punchId]};
                if(existingPunchDetails.version){
                  punch.version = existingPunchDetails.version+'1';
                }
              }
              // punches[i].push(punch)
              punches.push(punch);
            } else {
              // Other Day Records (Add 1 minute to start time)
              let punch = {};
              let startTime = previousEndTime; /* Add 1 minute here */
              let endTime = moment(startTime, 'HH:mm').add(hours, 'hours').format('HH:mm');
              previousEndTime = endTime;

              let inLocalTS = moment(start)
                .startOf("week")
                .add(i, "days")
                .add(moment.duration(startTime))
                .format(dateConfig.format4)
                .toString();
              let outLocalTS = endTime === "00:00" ? 
                moment(start)
                  .startOf("week")
                  .add(i+1, "days")
                  .add(moment.duration(endTime))
                  .format(dateConfig.format4)
                  .toString()
                : moment(start)
                  .startOf("week")
                  .add(i, "days")
                  .add(moment.duration(endTime))
                  .format(dateConfig.format4)
                  .toString();
              punch.inLocalTS = inLocalTS;
              punch.outLocalTS = outLocalTS;
              punch.inTS = new Date(inLocalTS).toISOString();
              punch.outTS = new Date(outLocalTS).toISOString();
              if(selectedWorker.timezone 
                && Object.keys(selectedWorker.timezone).length>0
                && selectedWorker.timezone.offset
                ){
                punch.inTS =  moment(inLocalTS).subtract(selectedWorker.timezone.offset * 60 * 60 * 1000).format( 'YYYY-MM-DDTHH:mm:ss.000')+'Z';
                punch.outTS = moment(outLocalTS).subtract(selectedWorker.timezone.offset * 60 * 60 * 1000).format( 'YYYY-MM-DDTHH:mm:ss.000')+'Z';
              }
              punch.actionBy = data.actionBy;
              punch.actionTS = data.actionTS;
              punch.buildingId = operationalBuilding;
              punch.districtId = operationalDistrict;
              punch.workerId = selectedWorker.workerId;
              punch.customerSite = "";
              if (data.customerSite)
                punch.customerSite = data.customerSite.trim();
              punch.activityName = "OUT";
              punch.status = "new";
              punch.category = "punch";
              punch.exceptionName = "";
              punch.isException = false;
              punch.jobName = selectedWorker && selectedWorker.jobRole ? selectedWorker.jobRole : '';;
              punch.activityGroup = PROJECT;
              punch.jobProjectInfo = record.details ? record.details : "";
              punch.projectDetails = "";
              if (record.projectDetails)
                punch.projectDetails = record.projectDetails ? record.projectDetails : '' ;
              punch.weekNumber = getWeekNumber(outLocalTS);
              let duration = 0;
              if (outLocalTS) {
                const end = moment(outLocalTS && outLocalTS.substr(0, 16));
                const start = moment(inLocalTS && inLocalTS.substr(0, 16));
                if (start.isValid() && end.isValid()) {
                  const diff = moment.duration(end.diff(start));
                  duration = diff.asHours();
                  duration = duration.toFixed(2);
                }
              }
              punch.duration = parseFloat(duration);
              const version = getUniqueID();
              punch.version = version;
              if (record.showFreeForm) punch.jobProjectInfo = record.freeForm;
              punch.deviceDetails = DEVICE_DETAILS;
              punch.jobType = selectedWorker.jobType ? selectedWorker.jobType : jobTypeITContractor;
              if(punchId){
                punch.id = punchId;
                punch.status = EDIT_STATUS;
                let existingPunchDetails = {...existingPunchesModify[punchId]};
                let punchVersion = existingPunchDetails.version ? existingPunchDetails.version+'1' : existingPunchDetails.version;
                punch.version = punchVersion;
              }
              // punches[i].push(punch)
              punches.push(punch);
            }
          }else if(punchId){
            let existingPunchDetails = {...existingPunchesModify[punchId]};
            let punchVersion = existingPunchDetails.version ? existingPunchDetails.version+'1' : existingPunchDetails.version;
            let deletePunch = {...existingPunchDetails, status:DELETED_STATUS, version:punchVersion};
            punches.push(deletePunch);
          }
        }
      }
      console.log('punches123', punches);
      if (!punches || punches.length <= 0){
        reject(new Error("NO data to upload"));
        return;
      }

      let punchesArray = [];
      let deletingPunches = [];
      console.log("Punches Array Data", punches);
      for (let j = 0; j < punches.length; j++) {
        let punchData = punches[j];

        const docRef = punchData.id ? collectionRef(PUNCHES).doc(punchData.id) : collectionRef(PUNCHES).doc();
        console.log("punch Id", docRef.id);
        let punchRecord = { ...punchData, id: docRef.id };
        console.log("punchRecord", punchRecord);
        punchesArray.push({ ...punchRecord });
        batch.set(docRef, punchData, { merge: true });
        if(punchData.id){
          const punchHistoryRef = collectionRef(PUNCHES).doc(punchData.id).collection('punchHistory').doc();
          const historyData = {...existingPunchesModify[punchData.id]};
          batch.set(punchHistoryRef, historyData, { merge: true });
        }
        if(punchRecord.status && punchRecord.status == DELETED_STATUS){
          deletingPunches.push({...punchRecord});
        }
      }
       await batch.commit();
      if(data.savePunchesToTimesheet){
        await createTimesheetfromContractorPunch(punchesArray)
        .then((result) => {
          if (result) {
            resolve(punches);
          }
        })
        .catch((error) => {
          console.log("error:", error);
          reject(error);
        });
      }else{
        resolve(true);
      }
      console.log("punchesArray", punchesArray, existingPunchesModify, deletingPunches);
      console.log("Successfully Uploaded bulk data");
    } catch (error) {
      console.log(error);
      reject(new Error("Bulk Upload Crashed"));
    }
  });
}

export const getContractorReportData = (managerId, startDate, endDate) => {
  console.log("utils > getContractorReportData called...");
  return new Promise(async (resolve, reject) => {
    try {
        const startDateWeekNumber = parseInt(getWeekNumber(startDate));
        const endDateWeekNumber = parseInt(getWeekNumber(endDate));
        const weekNumberArray = [];
        for(let i=startDateWeekNumber;i<=endDateWeekNumber;i++){
          weekNumberArray.push(i.toString());
        }
        console.log("getContractorReportData", startDateWeekNumber, endDateWeekNumber, weekNumberArray);
        const reportData = {};
        if(startDateWeekNumber && endDateWeekNumber && weekNumberArray.length>0){
          const collectionRef = db.collection("imTimeReports")
                                .doc('reports').collection('ITContractorPunches')
                                .where('weekNumber' , "in" , weekNumberArray);
                                //.where('weekNumber', "<", endDateWeekNumber);
          await collectionRef.get().then(snapshot => {
            console.log("getContractorReportData", snapshot.docs.length);
            if(snapshot.docs.length > 0){
              snapshot.docs.forEach(doc => {
                const docId = doc.id;
                const docData = doc.data();
                reportData[docId] = {...docData};
              })
            }
          })
          resolve(reportData);
        }else{
          reject("Please select Date");
        }
    }catch(err){
      reject(err);
      console.log("error in getContractorReportData", err);
    }
  })
}